import React, { useEffect } from "react";
import { object, number, string } from "prop-types";
import { SocialShare } from "@quintype/components";

import CardImage from "../../atoms/cardimage";
import FirstPublished from "../../atoms/first-published";
import Headline from "../../atoms/headline";
import SectionAndTimeStamp from "../../molecules/section-and-timestamp";
import SocialShareLinks from "../../molecules/social-share";
import BottomStoryElements from "../story-elements/bottom-story-elements";
import { Card } from "../story-elements";
import ReadFullArticle from "../story-elements/read-full-article";
import { AdFree, StoryResponsiveContainer } from "../../rows/ad-free";

import { getTitleAndCards } from "../../utils/utils";

import "./long-form.m.css";

const AdSlot = ({ mobile }) => (
  <AdFree>
    <StoryResponsiveContainer desktop="storyContentDesktop" mobile={mobile} />
  </AdFree>
);

AdSlot.propTypes = {
  mobile: string,
};

const LongForm = ({ story, index }) => {
  const [firstCard, ...cards] = story.cards;

  const handleStickyEvent = (container) => {
    var observer = new IntersectionObserver(
      function (entries) {
        // eslint-disable-line
        for (const entry of entries) {
          const stickyTarget = entry.target.parentElement.querySelector(".sticky-title");
          if (entry.intersectionRatio === 0) {
            stickyTarget.classList.add("sticky-title-element");
          } else if (entry.intersectionRatio === 1) {
            stickyTarget.classList.remove("sticky-title-element");
          }
        }
      },
      {
        threshold: [0, 1],
      }
    );

    Array.from(container.querySelectorAll(".container-top")).forEach((el) => {
      observer.observe(el);
    });
  };

  useEffect(() => {
    const container = document.querySelector(".long-form");
    handleStickyEvent(container);
  }, []);

  const newCards = getTitleAndCards(cards);

  return (
    <div>
      <div styleName="hero-image">
        <CardImage story={story} defaultWidth={710} aspectRatio={[4, 3]} imageType="image4x3" eager={true} />
        <div styleName="headline-block">
          <Headline text={story.headline} headerType={7} />
          {story.summary && <p styleName="summary">{story.summary}</p>}
        </div>
      </div>
      <div styleName="content">
        <div styleName="share-block">
          <SectionAndTimeStamp story={story} />
          <SocialShare template={SocialShareLinks} title={story.headline} url={story.slug} color="#fff" />
        </div>
        <ReadFullArticle storyIndex={index}>
          <div className="long-form">
            <Card key={firstCard.id} card={firstCard} story={story} />
            {newCards.length &&
              newCards.map(({ title, card }, index) => (
                <div styleName="card" key={index} id={card.id}>
                  <div className="container-top" />
                  <h2 className="sticky-title" styleName="sticky-title">
                    {title.text}
                  </h2>
                  <Card key={card.id} card={card} story={story} />
                  {index === 2 && <AdSlot mobile="storyPrem2" />}
                  {index === 4 && <AdSlot mobile="storyATF" />}
                  {index > 5 && index % 2 === 0 && <AdSlot mobile="storyBTF" />}
                </div>
              ))}
          </div>
          <FirstPublished story={story} />
        </ReadFullArticle>
        <BottomStoryElements story={story} index={index} />
      </div>
    </div>
  );
};

LongForm.propTypes = {
  story: object,
  index: number,
};

export default LongForm;
